import * as React from "react";

type SvgProps = {
  props?: string;
};
export function ResetIcon(props: SvgProps) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.645 2.35A7.958 7.958 0 007.995 0C3.575 0 .005 3.58.005 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08a5.99 5.99 0 01-5.65 4c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L8.995 7h7V0l-2.35 2.35z"
        fill="#2196F3"
      />
    </svg>
  );
}
